import publicRuntimeConfig from "@FRAMEWORK/config/public";
import logger from "@FRAMEWORK/utils/logger";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {useQuery, UseQueryOptions} from "@tanstack/react-query";

type GlobalMenu = {
	align: string; // 중앙정렬 여부
	allOpenYn: string;
	areaMainYn: string;
	classNm: string;
	commCdNm: string;
	dspGrpCd: string;
	dspMenu: string;
	dspNm: string;
	dspOrder: number;
	dspSid: string;
	dspSidHi: string;
	dspSidLoc: string;
	dspTypeCd: string;
	dspUrl: string;
	gnbTypeCd: string;
	homeYn: string;
	iconType: string;
	iconYn: string;
	keywordYn: string;
	locTypeCd: string;
	lv: number;
	mdspUrl: string;
	menuTypeCd: string;
	mnewWindowYn: string;
	mobileYn: string;
	newWindowYn: string;
	singleTypeCd: string;
	subDspNm: string;
	subDspOrder: number;
	subDspTypeCd: string;
	subDspUrl: string;
	tempRervCntYn: string;
	themaYn: string;
	useYn: string;
	webMenuPftype: string;
	webMenuTarget: "SELF" | "NEW" | "IFRAME";
	mwebMenuTarget: "SELF" | "NEW" | "IFRAME";
};

type GlobalMenuBff = {
	menuLv1List: GlobalMenu[];
	menuLv2List: GlobalMenu[];
	menuLv3List: GlobalMenu[];
	menuLv4List?: GlobalMenu[];
	pmoMenuList: GlobalMenu[];
	subMenuList: GlobalMenu[];
};

const key = "useGlobalMenuBFF";
const getPath = (): string | null => `/bff/global/menu`;
const defaultData = {
	dspTypeCd: "A",
	dspSid: "A000000",
	level: "1,2,3",
};

/** ```
 * 공통메뉴정보 BFF
 *   `/bff/global/menu`
 * ```*/
const globalMenuAsync = (params = defaultData) =>
	useConfigureAxios({url: `${publicRuntimeConfig.ENV_PRODUCT_URL}${getPath()}`, params});

/**
 * @description 공통메뉴정보 BFF
 */
const useGlobalMenu = (params = defaultData, options?: Partial<UseQueryOptions<{body: GlobalMenuBff}>>) => {
	try {
		return useQuery({
			queryKey: [key, JSON.stringify(params)],
			queryFn: () => useConfigureAxios(getPath(), {params}).then(r => r.data),
			staleTime: Infinity,
			gcTime: Infinity,
			throwOnError: true,
			placeholderData: {
				body: {
					menuLv1List: [],
					menuLv2List: [],
					menuLv3List: [],
					menuLv4List: [],
					pmoMenuList: [],
					subMenuList: [],
				},
			},
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};

export default useGlobalMenu;
export {globalMenuAsync};
export type {GlobalMenu, GlobalMenuBff};
